import Vue from 'vue';
let outerContext;

const ErrorPlugin = {
  install(Vue,) {
    Vue.prototype.$error = {
      sanitize() {
        errorCheck(outerContext)
      }
    }
  }
}

Vue.use(ErrorPlugin);

export default function errorCheck(context) {
  if (!outerContext) {
    outerContext = context;
  }
  const shouldWork = process.client && window.__NUXT__ && window.__NUXT__.state && context.store.state.homeDrushim.initialized;
  if (!shouldWork) {
    return;
  }
  
  const temp = context.store.getters
  const failedGetters = []

  Object.keys(temp).forEach((item) => {
    try {
      temp[item];
    } catch (err) {
      failedGetters.push(item)
      context.store.commit('SET_ERROR', item)
    }
  })
  context.store.commit('SET_SANITIZED', true)

  return failedGetters;
}
